import axios from "axios";

const SESSION_TOKEN_KEY = "atlas.sessionToken";

// Returns true when the request is headed for our own backend (and therefore
// should carry the session token). Relative URLs are same-origin, so they
// count too. Absolute URLs to other hosts (e.g. Azure DevOps) are left alone.
const isBackendRequest = (config) => {
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const url = config.url ?? "";
  const base = config.baseURL ?? "";

  // Relative URL with no overriding baseURL -> same origin -> our backend.
  if (!/^https?:\/\//i.test(url) && !/^https?:\/\//i.test(base)) {
    return true;
  }

  const target = base || url;
  return Boolean(apiEndpoint) && target.startsWith(apiEndpoint);
};

/**
 * Registers a global axios request interceptor that attaches the stored
 * session token as a Bearer Authorization header on every call to our backend.
 * Call once at app startup. Requests that already set their own Authorization
 * header (e.g. Basic auth to external services) are left untouched.
 */
export const setupAxiosAuth = () => {
  axios.interceptors.request.use((config) => {
    if (!isBackendRequest(config)) {
      return config;
    }

    config.headers = config.headers ?? {};

    if (!config.headers.Authorization) {
      const token = localStorage.getItem(SESSION_TOKEN_KEY);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    if (!config.headers.Accept) {
      config.headers.Accept = "application/json";
    }

    return config;
  });
};

export default setupAxiosAuth;
